import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const MANAGERS = ["SUPERADMIN", "DIRECAO"];
export const MERENDA_ROLES = [...MANAGERS, "COZINHEIRA"];

export const todayISO = () => {
  const d = new Date();
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
};
export const thisYM = () => todayISO().slice(0, 7);
export const newReqId = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random()}`);
export const fmtQ = (v) => (v === null || v === undefined ? "—" : Number(v).toLocaleString("pt-BR", { maximumFractionDigits: 3 }));
export const toNum = (v) => (v === "" || v === null || v === undefined ? null : Number(String(v).replace(",", ".")));
export const fmtDate = (iso) => (iso ? iso.split("-").reverse().join("/") : "—");

export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (!d) return "Algo deu errado. Tente novamente.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return d.message || JSON.stringify(d);
}

export function useMerendaMeta() {
  const { scopeParams, selectedSchoolId, user } = useAuth();
  const [meta, setMeta] = useState(null);
  const [foods, setFoods] = useState([]);
  const reload = useCallback(async () => {
    const [m, f] = await Promise.all([api.get("/merenda/meta", { params: scopeParams }), api.get("/merenda/foods", { params: scopeParams })]);
    setMeta(m.data); setFoods(f.data);
  }, [scopeParams]);
  useEffect(() => { reload().catch(() => setMeta(false)); }, [selectedSchoolId]); // eslint-disable-line react-hooks/exhaustive-deps
  const canManage = MANAGERS.includes(user?.role);
  return { meta, foods, reload, scopeParams, canManage };
}

export const PageHead = ({ title, subtitle, children }) => (
  <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
    <div>
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-orange-600">Mapa de Merenda</p>
      <h1 className="font-display text-2xl font-black text-slate-900 sm:text-3xl">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
    </div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);

export const FoodSelect = ({ foods, value, onChange, testid, className = "" }) => (
  <select value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={testid}
    className={`h-10 w-full rounded-md border border-slate-200 bg-white px-2 text-sm ${className}`}>
    <option value="">Selecione o alimento…</option>
    {foods.filter((f) => f.active !== false || f.id === value).map((f) => <option key={f.id} value={f.id}>{f.name} ({f.unit})</option>)}
  </select>
);
